import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-common-confirmation-modal',
  templateUrl: './common-confirmation-modal.component.html',
  styleUrls: ['./common-confirmation-modal.component.scss']
})
export class CommonConfirmationModalComponent {
  headerText = this.config.data.headerText;
  bodyText = this.config.data.bodyText;
  successIcon = this.config.data.successIcon;
  errorIcon = this.config.data.errorIcon;
  constructor(
    private readonly ref : DynamicDialogRef, 
    private readonly config: DynamicDialogConfig
  ){}

onConfirm(): void {
    this.ref.close(true);
  }

  onCancel(): void {
    this.ref.close(false);
  }
}
